<template>
    <div>
        <b-container fluid>
            <!--
            <b-row style="margin-top:20px; margin-left:10px" >
                <b-col>
                    <h4>Buy Directly From Your Local Breweries</h4>
                </b-col>
            </b-row>
            -->

            <!-- Top carousel. Only show on large screens. ONLY ON UI VERSION 1 -->
             <b-row class="d-none d-md-block"  style="margin-top:10px; margin-left:20px; margin-right:20px; background-color:#f2f2f2; height:320px; border-radius:10px">
                <b-col>
                    <carousel :perPageCustom="[[750, 4],[1070, 6], [1100, 10]]"  :mouse-drag="false" 
                    :autoplay="true" :loop="true" :autoplayHoverPause="false" :autoplayTimeout="4000" :navigationEnabled="true" 
                    paginationActiveColor="#2e5189" paginationColor="#fff" 
                    
                    >
                        <!-- Full screen brand slide only if not mobile -->
                        <slide v-if="!isMobile">
                            <div class="brandslide">
                                <b-container fluid>
                                    <b-row>
                                        <b-col style="width:100%; text-align:center">
                                            <img height="220px" src="../assets/manifesto1.jpg" style="margin-top:0px; text-align: center;"/>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </div>
                        </slide>
                        <template  v-for="(brewer, index) in brewersList" >
                            <slide :key="index" v-if="brewer.logoFileThumbnailURL&&!brewer.distbrewerid" style="; margin-left:0px">
                                <b-card style="width:140px; height:220px; margin-top:10px;; margin-left:0px; text-align:center; cursor: pointer"  @click="viewBrewerProfile(brewer)">
                                    <b-row>
                                        <b-col>
                                            <div style="height:125px">
                                                <img  style="cursor: pointer;" :src="brewer.logoFileThumbnailURL" width="110"  fluid alt="Logo image" >
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <div style="font-size:12px">
                                                {{brewer.company}}
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </slide>
                        </template>
                    </carousel>
                </b-col>
            </b-row>

            <!-- Beer table and breweries content row -->
            <b-row style="margin-top:20px">
                <!--------------------------------------------->
                <!-- Left column for breweries, UIVersion==1 -->
                <!--------------------------------------------->
                <b-col cols='2' class="d-none d-lg-block" >
                    <b-card style="background-color:#f2f2f2">
                    <b-container fluid>
                        <b-row>
                            <b-col>
                            <div><h4>Breweries</h4></div>
                                <template v-for="brewer in sortedBrewersList">
                                    <!-- Each brewery -->
                                    <div v-if="brewer.isbrewer==1" :key="brewer.company" @click="viewBrewerProfile(brewer)" style="cursor:pointer; margin-top:5px">
                                        <small style="">{{brewer.company}}</small>
                                        <div v-if="brewer.distributorName" style="font-size:10px; color:grey">By {{brewer.distributorName}}</div>
                                        <div style="border-bottom: 1px solid #cccccc "></div>
                                    </div>
                                </template>
                            </b-col>
                        </b-row>
                        <hr>
                    </b-container>
                    </b-card>
                </b-col>
                <!------------------------------->
                <!-- Right column for beers -->
                <!------------------------------->
                <b-col>
                    <!-- If brewer looking at beers, don't show shopping buttons etc -->
                    <div v-if="userProfile.isbrewer>0">
                        <beertable :everyAvailableBeer="everyAvailableBeer" :shouldShowSearch = 1 :shouldAllowShopping=0 />
                    </div>
                    <div v-else>
                        <beertable :everyAvailableBeer="everyAvailableBeer" :shouldShowSearch = 1 :shouldAllowShopping=1 />
                    </div>
                </b-col>
            
            <!-- End of breweries and beer content row -->
            </b-row>
        </b-container>
        <footer><pagefooter/></footer>
        

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Beertable from './Beertable'
    import Pagefooter from './Pagefooter'
    import { Carousel, Slide } from 'vue-carousel';
    const fb = require('../firebaseConfig.js')

    export default {
        components: {
            Beertable,
            Pagefooter,
            Carousel,
            Slide,
        },
        data() {
            return {
                enableAds:true,
                windowWidth:0,
                isMobile: false,
                prevLabel:"&#10096",

            }
        },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'everyAvailableBeer', 'userCart', 'brewersList', 'favoriteBrewersList', 'allowDistributors', 
            'allBrewersList', 'uiVersion']),

            sortedBrewersList(){
                //This is to remove sortel list from being reactive. Otherwise msort modifies the original list
                var _sortedList = JSON.parse(JSON.stringify(this.brewersList))
                    function compare(a, b) {
                        // Use toUpperCase() to ignore character casing
                    const costA = a.company.toLowerCase();
                    const costB = b.company.toLowerCase();

                    let comparison = 0;
                    if (costA >costB) {
                            comparison = 1;
                    } else if (costA<costB) {
                            comparison = -1;
                    }
                        return comparison;
                }
                _sortedList.sort(compare);
                return _sortedList
        },

       },


        methods: {
            viewBrewerProfile(brewer){
                var brewerId=brewer.uid
                var distbrewerid=''
                if(brewer.distbrewerid) distbrewerid=brewer.distbrewerid

                //Store the click
                if(this.currentUser){
                    //Add to colletion
                    var theData = {
                        pub:this.userProfile.company,
                        pubid:this.currentUser.uid,
                        brewerid:brewer.uid,
                        createdOn: new Date(),
                    }
                fb.clickedBrewerCollection.add(theData)
                }

                this.$router.push({ path: 'breweryprofile', query: { brewerId: brewerId, distbrewerid:distbrewerid }})
            },
            onResize() {
                this.isMobile = window.innerWidth < 600
            }

        },

    //To check if this is a movile device
    mounted() {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },

    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },
        
    }
</script>
<style scoped>
.b-row.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.brandslide{
     width: 95vw;
     padding-left:20px;
     padding-right:20px;
    text-align: center;
}

</style>
